import React, {useMemo} from 'react';
import {Column} from '@tanstack/react-table';

export function Filters({
                          column,
                        }: {
  column: Column<any>;
}) {
  const columnFilterValues = (
    String(column.getFilterValue() ?? '').split(';') ?? []
  ).filter((value) => !!value);

  const uniqueValues = column.getFacetedUniqueValues();
  const sortedUniqueValues = useMemo(() => {
    const values = Array.from(uniqueValues.keys());
    if (Array.isArray(values[0])) {
      const uniqueSet = new Set(values.flat());
      return Array.from(uniqueSet).sort();
    }
    return values.sort();
  }, [uniqueValues]);

  const filterLabels = {
    field_indicator_thema: 'Thema',
    field_indicator_type: 'Type',
  };

  const id = column.id as keyof typeof filterLabels;

  return filterLabels[id] === undefined ? null : (
    <div className="vl-u-bg-alt" style={{padding: '2.4rem'}}>
      <p className="vl-u-text--uppercase vl-u-text--small vl-u-text--bold">
        {filterLabels[id]}
      </p>
      {sortedUniqueValues.map((value: any, index: number) => {
        return (
          <label
            key={index}
            className="vl-checkbox vl-checkbox--block vl-u-spacer-top--xsmall"
            htmlFor={value}
          >
            <input
              className="vl-checkbox__toggle"
              type="checkbox"
              id={value}
              name={value}
              checked={columnFilterValues.includes(value)}
              value={value}
              onChange={(event) => {
                if (columnFilterValues.includes(event.target.value)) {
                  column.setFilterValue(
                    columnFilterValues
                      .filter((filterValue) => filterValue !== event.target.value)
                      .join(';'),
                  );
                  return;
                }

                columnFilterValues.push(event.target.value);
                column.setFilterValue(columnFilterValues.join(';'));
              }}
            />
            <div className="vl-checkbox__label">
              <i className="vl-checkbox__box" aria-hidden="true"/>
              {value}
              <span style={{display: 'inline-block', margin: '0 0 0 auto', textAlign: 'right'}}>
                {uniqueValues.get(value) || 0}
              </span>
            </div>
          </label>
        );
      })}
    </div>
  );
}
